module.exports = __webpack_public_path__ + "img/user-group.623808f3.svg";